export default __webpack_public_path__ + "static/media/iconFavorite.9d4dc056.svg";